<template>
  <div id="search" class="search-group inline-form mt-3" role="search">
    <label class="sr-only" for="quick-search" aria-label="Quick Search">Quick Search</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span aria-hidden="true" class="input-group-text">
          <i aria-hidden="true" class="text-slate gel-icon-search gel-icon-lg"></i>
        </span>
      </div>
      <input
        id="quick-search"
        v-model="search"
        class="form-control"
        placeholder="Search"
        type="search"
      />
    </div>
    <SearchResult :results="results" @clear-search="clearSearch" :currentSearch="search"></SearchResult>
  </div>
</template>

<script>
import SearchResult from "@/components/SearchResult.vue";

export default {
  name: "Search",
  data() {
    return {
      search: "",
      dataString: ""
    };
  },
  components: {
    SearchResult
  },
  computed: {
    results: function() {
      let searchTerm = this.search.replace(/\s/g, "").toLowerCase();
      if (searchTerm.length > 2) {
        let yamlData = this.$root.yamlData;
        if (this.dataString === "") {
          this.stringifyData();
        }
        let match = this.dataString.match(new RegExp(searchTerm, "ig"));
        if (match) {
          let results = [];
          for (let submenuName of Object.keys(yamlData)) {
            for (let menuItem of Object.keys(yamlData[submenuName])) {
              for (let data of Object.values(yamlData[submenuName][menuItem])) {
                if (data) {
                  if (Array.isArray(data)) {
                    data.forEach(arrayItem => {
                      if (
                        arrayItem
                          .toLowerCase()
                          .match(new RegExp(searchTerm, "ig"))
                      ) {
                        results.push({
                          category:
                            submenuName.charAt(0).toUpperCase() +
                            submenuName.substring(1),
                          route: menuItem,
                          title: yamlData[submenuName][menuItem].name,
                          match: arrayItem
                        });
                      }
                    });
                  } else {
                    if (
                      data.toLowerCase().match(new RegExp(searchTerm, "ig"))
                    ) {
                      results.push({
                        category:
                          submenuName.charAt(0).toUpperCase() +
                          submenuName.substring(1),
                        route: menuItem,
                        title: yamlData[submenuName][menuItem].name,
                        match: data
                      });
                    }
                  }
                }
              }
            }
          }
          return results;
        }
      }
      return [];
    }
  },
  methods: {
    clearSearch: function() {
      this.search = "";
    },
    stringifyData: function() {
      this.dataString = JSON.stringify(this.$root.yamlData);
    }
  }
};
</script>